export const REVIEWING_TAX_ENTRIES_CHUNK_SIZE = 4;
export const DECLINING_TAX_ENTRIES_CHUNK_SIZE = 40;
